(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/team/assets/javascripts/use-competition-signup-time.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/team/assets/javascripts/use-competition-signup-time.js');

'use strict';

const {
  useEffect,
  useState,
  useRef,
  useMemo
} = React;
const {
  resolveTimeZone
} = svs.components.lbUtils.helpers.formatDate;
const useIsBeforeSignupEndTime = _ref => {
  let {
    competition
  } = _ref;
  const signupEndTime = useMemo(() => (competition === null || competition === void 0 ? void 0 : competition.signupEndTime) || new Date(new Date(competition === null || competition === void 0 ? void 0 : competition.signupStartTime).getTime() + 86400000 * 7), [competition]);
  const getDiffDateFromNow = date => resolveTimeZone(new Date(date).getTime()) - resolveTimeZone(Date.now());
  const [isBeforeSignupEndTime, setIsBeforeSignupEndTime] = useState(signupEndTime && getDiffDateFromNow(signupEndTime) > 0);
  const [isBeforeSignupEndTimeState, setIsBeforeSignupEndTimeState] = useState(signupEndTime);
  const timeoutToSignupEndTime = useRef();
  useEffect(() => {
    if (signupEndTime !== isBeforeSignupEndTimeState && resolveTimeZone(new Date(signupEndTime)) < resolveTimeZone(new Date())) {
      setIsBeforeSignupEndTime(false);
      setIsBeforeSignupEndTimeState(signupEndTime);
    }
  }, [signupEndTime, isBeforeSignupEndTimeState]);
  useEffect(() => {
    if (signupEndTime && getDiffDateFromNow(signupEndTime) > 0) {
      if (!timeoutToSignupEndTime.current) {
        timeoutToSignupEndTime.current = setTimeout(() => setIsBeforeSignupEndTime(true), getDiffDateFromNow(signupEndTime));
      }
    }
    return () => {
      if (timeoutToSignupEndTime.current) {
        clearTimeout(timeoutToSignupEndTime.current);
      }
    };
  }, [signupEndTime]);
  return isBeforeSignupEndTime;
};
const useIsBeforeSignupStartTime = _ref2 => {
  let {
    competition
  } = _ref2;
  const {
    signupStartTime
  } = competition || {};
  const currentTime = resolveTimeZone(new Date());
  const signUpStartTime = resolveTimeZone(new Date(signupStartTime));
  return currentTime < signUpStartTime;
};

setGlobal('svs.components.marketplaceCompetition.team.useCompetitionSignupTime', {
  useIsBeforeSignupEndTime,
  useIsBeforeSignupStartTime
});

 })(window);